import { mapGetters } from 'vuex';
import { initDycolor } from '~';

initDycolor('creative-status', require(`${process.env.DYCOLOR_REQUIRE}./CreativeStatus.scss`)); // eslint-disable-line

export default {
  computed: {
    ...mapGetters('creative', { creative: 'currentCreative' }),
    statusName() {
      return this.creative ? this.$t(`terms.creative-flow-statuses.${this.creative.status}`) : null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/lab/creative-status/CreativeStatus.js